import { ICompactProduct } from "api/interfaces/get-page-details/common/CompactProduct.type";
import classNames from "classnames";
import PAImage from "component/design-system/images/PAImage";
import PAText, { FONT_SIZE } from "component/design-system/typography/PAText/PAText";
import { renderHTML } from "util/DomHelper";
import { getRelativeImagePath } from "util/helper/getRelativeImagePath";
import HideIf from "util/HideIf";
import { isApparelProduct } from "util/product/apparel";
import styles from "./product-highlights.module.scss";

interface IProps {
  productHighlights: any[];
  product?: ICompactProduct;
  className?: string;
  hideBulletPoints?: boolean;
  isGridView?: boolean;
}

function ProductHighlightsV2(props: IProps) {
  const {
    className = "", productHighlights, product, hideBulletPoints = false, isGridView = false,
  } = props;

  const isApparel = product && isApparelProduct(product);

  return (
    <div
      className={classNames(`product_full_width ${styles.product_highlights} ${styles.product_highlights_v2}`, { [styles.product_hightlights_category]: hideBulletPoints, [styles.product_hightlights_category_grid]: isGridView }, className)}
    >
      <div className={styles.highlights_container}>
        {productHighlights?.map((highlight: any) => {
          const {
            name, value, iconImage, bulletPoints = [], description, article,
          } = highlight?.uiDetails?.content || highlight || {};

          return (
            <div key={highlight.url} className={styles.highlight_v2}>
              <div className={styles.tag_img_container}>
                <PAImage
                  src={getRelativeImagePath(iconImage?.startsWith("/") ? iconImage : `/${iconImage}`)}
                  width={34}
                  height={34}
                  alt={`${name}: Unveil Product Features with Product Highlights`}
                  className={styles.tag_img_v2}
                />
              </div>

              <div className={`${styles.product_highlight_description} ${styles.product_highlight_description_v2}`}>
                <PAText
                  component="span"
                  className={`m-b-0 m-t-0 ${styles.label}`}
                  fontSize={FONT_SIZE[0]}
                >
                  {name}
                </PAText>

                <HideIf show={!isApparel}>
                  <PAText
                    component="div"
                    className={styles.value}
                  >
                    {value}
                  </PAText>
                </HideIf>

                <HideIf show={isApparel}>
                  <PAText
                    component="div"
                    className="m-b-0"
                    fontSize={FONT_SIZE[0]}
                  >
                    {description}
                  </PAText>
                </HideIf>

                <HideIf show={isApparel}>
                  <div dangerouslySetInnerHTML={renderHTML(article)} />
                </HideIf>
                <HideIf show={!hideBulletPoints}>
                  <ul className="m-t-10">
                    {bulletPoints.map((bullet) => (
                      <li className={styles.bullet_points} key={bullet}>{bullet}</li>
                    ))}
                  </ul>
                </HideIf>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}

export default ProductHighlightsV2;
